import {all} from 'redux-saga/effects';

import address from './address'
import data from './data'

export default function* rootSaga() {
    yield all([...address, ...data]);
};
